import FullHeightTablist from './fullheight-tablist'

export default FullHeightTablist
